import dayjs from "dayjs";
import { validateNumber, validateEmail, validateMobileNumber, validateMobileNumberWithoutCode } from "./apiHelperFunctions";
import ReactGA from "react-ga4";
import sjcl from "sjcl";
import { parseJwt } from "./genericFunction";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import LanguageTranslator from "../locals/LanguageTranslator";
import { Tooltip } from "antd";
import { Box, Package2 } from "lucide-react";
export function validatePincode(val) {
    return val !== "" && val.match(/^[0-9]{6}$/) ? true : false;
    // return val !== "" && val.match(/^[1-9][0-9]{5}$/) ? true :false;
}

export function changeKey(key) {
    if (key.includes("order")) return "orderNumber"
    else if (key.includes("shipment")) return "shipmentAdviceCode"
    else if (key.includes("asnMask")) return "shipmentAdviceCode"
    else if (key.includes("logistic")) return "logisticNumber"
    else if (key.includes("set")) return "setBarCode"
    else if (key.includes("item")) return "itemCode"
    return key;
}

// Function : To check for the mandatory condition for multiple inputs 
export const finalSubmitMandatoryValidationsCheck = (inputFields, state, labelKey, parameters = {}) => {

    const getLabel = (item) => {
        return typeof item?.[labelKey] == "function" ? item?.[labelKey]?.() : item?.[labelKey]
    }

    let { decimalPoint } = parameters;
    let updatedErrorData = {}
    inputFields?.forEach((item, inputIndex) => {

        updatedErrorData[item?.key] = [];
        // Mandatory condition check
        if ((item?.mandatory ? (typeof (item?.mandatory) == "function" ? item?.mandatory() : item?.mandatory) : false) && !state?.[item?.key]) {
            let avoidMandatoryCheck = item?.avoidMandatoryCheck ? typeof (item?.avoidMandatoryCheck) == "function" ? item?.avoidMandatoryCheck() : item?.avoidMandatoryCheck : false;
            if (!avoidMandatoryCheck) {
                updatedErrorData?.[item?.key].push(`${getLabel(item) || "This"} is a mandatory field, please provide a valid value inside input.`)
            }
        }
        else if (item?.mandatory && item?.type === "upload" && state?.[item?.key] && state?.[item?.key]?.length == 0) {
            updatedErrorData?.[item?.key].push(`${getLabel(item) || "This"} is a mandatory field, please provide a valid value inside input.`)
        }
        else if (item?.type === "number" && state?.[item?.key]) {
            let errorMessages = validateNumber(state?.[item?.key] || "", "number", "number")
            errorMessages?.length > 0 && updatedErrorData?.[item?.key].push(...errorMessages);
        } else if (item?.type === "decimal" && state?.[item?.key]) {
            let errorMessages = validateNumber(state?.[item?.key] || "", "decimal", "decimal", decimalPoint)
            errorMessages?.length > 0 && updatedErrorData?.[item?.key].push(...errorMessages);
        } else if (item?.type === "email" && state?.[item?.key]) {
            let isEmailValid = validateEmail(state?.[item?.key])
            !isEmailValid && updatedErrorData?.[item?.key].push(`Please provide a valid email inside ${getLabel(item)} input field.`);
        }
        else if (item?.type === "mobileNo" && state?.[item?.key]) {
            let isMobileNumberValid = validateMobileNumber(state?.[item?.key])
            !isMobileNumberValid && updatedErrorData?.[item?.key].push(`Please provide a valid mobile number inside ${getLabel(item)} input field.`);
        }
        else if (item?.type === "mobileNoWithoutCode" && state?.[item?.key]) {
            let isMobileNumberValid = validateMobileNumberWithoutCode(state?.[item?.key])
            !isMobileNumberValid && updatedErrorData?.[item?.key].push(`Please provide a valid mobile number inside ${getLabel(item)} input field.`);
        }

        if (item?.validationFunction) {
            let errorMessages = item?.validationFunction(state?.[item?.key]);
            errorMessages?.length > 0 && updatedErrorData?.[item?.key].push(...errorMessages);
        }

        if (updatedErrorData?.[item?.key]?.length === 0) {
            delete updatedErrorData?.[item?.key];
        }
    })
    return updatedErrorData
}

// Function -> To replace the image if image not gets loaded
export const handleImageError = (e, imagePath) => {
    const img = document.createElement("img");
    img.src = imagePath;
    img.alt = "Image Not available";
    img.className = "pltmt-img";
    e.target.replaceWith(img);
}

export const getCurrentDomain = (window) => {
    return window.location.origin;
};


export const getEnterprises = (config = {}) => {
    let { userDetails = {} } = config || {};
    let loginResponse = JSON.parse(userDetails?.["loginResponse"] || "{}") || {};
    return loginResponse?.entDetails || []

}

export function onDragEnd(fromIndex, toIndex, config) {
    let { selectedData = {} } = config;
    const data = Object.keys(selectedData || {});
    const item = data.splice(fromIndex, 1)[0];
    data.splice(toIndex, 0, item);
    let dataObject = {};
    data.forEach((item) => {
        dataObject[item] = selectedData[item]
    });
    return dataObject;
}


// Function : To update the cache and clear all the data inside from the cache
export function emptyCache() {
    if ('caches' in window) {
        let flag = false;
        caches.keys().then((names) => {
            // Delete all the cache files
            names.forEach(name => {
                caches.delete(name);
                flag = true;
            })
        });

        // Makes sure the page reloads. Changes are only visible after you refresh.
        flag && window.location.reload(true);
    }
}

export function getCurrentDateFormat(dateString) {

    if (dateString) {
        const formats = [
            "DD MMMM YYYY",
            "DD MMM YYYY",
            "YYYY-MM-DD",
            "YYYY/MM/DD HH:mm",
            "DD MMMM YYYY HH:mm",
            "DD MMM YYYY HH:mm",
            "DD-MM-YYYY HH:mm",
            "YYYY-MM-DD HH:mm",
            "DD MMM YYYY 'AT' HH:mm",
            'YYYY-MM-DDTHH:mm:ssZ',
            "E MMM dd HH:mm",
            'MM/DD/YYYY',
            'DD-MM-YYYY',
            'YYYY/MM/DD',
            'DD/MM/YYYY',
            "MMM DD, YYYY",
            "MMMM DD, YYYY",
            "DDth MMM YYYY",
            "MM-DD-YYYY",
            "YYYY.MM.DD",
            "MM.DD.YYYY",
            "DD.MM.YYYY",
            "YYYY-MM-DD HH:mm:ss",
            "MM/DD/YYYY HH:mm:ss",
            "DD/MM/YYYY HH:mm:ss",
            "MMM DD, YYYY HH:mm:ss",
            "YY-MM-DD",
            "MM/DD/YY",
            "DD/MM/YY",
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
            // Add other formats as needed
        ];

        let matchedFormat = null;

        for (const format of formats) {
            const parsedDate = dayjs(dateString, format, true); // strict parsing
            if (parsedDate.isValid()) {
                matchedFormat = format;
                break;
            }
        }
        return matchedFormat;
    }

    return null

}

// Function : To get the type based on the url 
export const getFileTypeFromUrl = (url) => {
    if (!url) return '';

    try {
        const fileUrl = url.split('?')[0]; // remove query params
        const lastDotIndex = fileUrl.lastIndexOf('.');
        if (lastDotIndex === -1) return '';

        return fileUrl.slice(lastDotIndex + 1).toLowerCase(); // always return lowercase
    } catch (e) {
        console.error("Error parsing file type from URL:", e);
        return '';
    }
}


// Function : To get the name of the file type based on the extension of file
export const getFileNameFromExt = (ext) => {
    let fileName = '';
    switch (ext) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case "avif":
        case "webp":
            fileName = 'image';
            break;
        case 'mp4':
        case '.mov':
        case '.wmv':
        case 'avi':
        case 'webm':
            fileName = 'video';
            break;
        case 'doc':
        case 'docx':
            fileName = 'doc';
            break;
        case 'xls':
        case 'xlsx':
        case 'csv':
        case 'xml':
            fileName = 'excel';
            break;
        case 'pdf':
            fileName = 'pdf';
            break;
        default: {
            fileName = 'file';
            break;
        }
    }
    return fileName;
}

// Function : To convert the file disposition type to inline
export const convertNormalFileUrlIntoDispositionUrl = (url) => {

}
export function convertToCron(dateString) {
    const date = new Date(dateString);

    const minute = date.getMinutes();
    const hour = date.getHours();
    const dayOfMonth = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-indexed in JS, so we add 1
    const dayOfWeek = '*'; // Cron doesn't require day of the week for specific date

    // Constructing cron expression
    const cronExpression = `${minute} ${hour} ${dayOfMonth} ${month} ${dayOfWeek}`;
    return cronExpression;
}

export function convertCronToDate(cronExpression) {
    const cronParts = cronExpression.split(' ');

    if (cronParts.length !== 5) {
        return null;
    }

    const minute = parseInt(cronParts[0], 10);
    const hour = parseInt(cronParts[1], 10);
    const dayOfMonth = parseInt(cronParts[2], 10);
    const month = parseInt(cronParts[3], 10) - 1; // Month is 0-indexed in JavaScript

    // Create the current date and override the cron parts
    const now = new Date();
    const year = now.getFullYear(); // You can modify this if you want a specific year

    // Create the date object
    const date = new Date(year, month, dayOfMonth, hour, minute);

    // Use Day.js to format the date
    return dayjs(date);
}

// Function : To get the name of the file type based on the extension of file
export const sendButtonClickEventToGoogleAnalytics = (config = {}) => {

    let { label, location } = config || {};

    if (!["quality.supplymint.com", "dev.supplymint.com", "localhost"]?.some(item => window.location.hostname?.includes(item))) {
        ReactGA.event({
            category: "Button",
            action: "button_click",
            path: location.pathname,
            label: label,
        });
    }
}


export const getLocation = ({
    setLocation,
    setError,
}) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
                setError(null);
            },
            (err) => {
                setError(err.message);
            }
        );
    } else {
        setError("Geolocation is not supported by this browser.");
    }
};


// function to validate the username
export const validateUsername = (username) => {
    let errors = [];
    if (username) {
        if (username.length < 3) {
            errors.push("Username must be at least 3 characters long!");
        }
        if (!/^[a-z0-9@._]*$/.test(username)) {
            errors.push("Username can only contain lowercase letters, digits, and the characters @, ., and _.");
        }
    } else {
        errors.push("Please enter a valid Username!");
    }
    return errors.length > 0 ? errors : null;
};


export const formatFileSize = (sizeInBits) => {
    if (sizeInBits === 0) return "0 Bytes";

    const units = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    const sizeInBytes = sizeInBits / 8; // Convert bits to bytes
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));

    return `${(sizeInBytes / Math.pow(1024, i)).toFixed(2)} ${units[i]}`;
};

// Function : To encode the data inside the object 
export const modifyDataForDocumentViewerUrlInsertion = (type, obj) => {
    const secretKey = "document-viewer-supplymint-key"; // Replace with your unique secret key

    const encodeKey = (key) => {
        return sjcl.encrypt(secretKey, JSON.stringify(key));
    };

    const decodeKey = (key) => {
        return JSON.parse(sjcl.decrypt(secretKey, key))
    };

    if (!obj || typeof obj !== 'object') {
        throw new Error("Invalid input: obj must be an object.");
    }

    const processKeys = (inputObj, processor) => {
        return Object.fromEntries(
            Object.entries(inputObj).map(([key, value]) => [
                key,
                value && value != undefined && value != null ? processor(value) : value,
            ])
        );
    };

    switch (type) {
        case "encode": {
            return processKeys(obj, encodeKey);
        }
        case "decode": {
            return processKeys(obj, decodeKey);
        }
        default: {
            throw new Error("Invalid type: must be 'encode' or 'decode'.");
        }
    }
};


export const getMenuMode = () => {
    let tokenData = parseJwt(sessionStorage.getItem("token"));
    let mode = localStorage?.getItem(`menuMode-${tokenData?.jti}`);
    return mode;
}

export const getCurrentPageModuleCode = (config = {}) => {
    let { userDetails = {}, location } = config || {};
    let mainMenu = userDetails?.mainMenu;
    let moduleCode = "";

    let moduleList = typeof (mainMenu) == "string" ? JSON.parse(mainMenu || "{}")?.moduleList?.[0]?.[0] : {};


    const getActiveModuleCode = (list) => {
        for (let item of list) {
            if (item?.pageUrl?.replace('#', '') == location.pathname) {
                moduleCode = item?.code;
                break;
            } else if (item?.subModules?.length > 0) {
                getActiveModuleCode(item?.subModules || []);
            }
        }
        return;
    }

    // Find module code
    getActiveModuleCode(moduleList?.subModules || []);

    return {
        activeModule: userDetails?.current_main_menu_local_config?.activeModule || "",
        moduleCode: moduleCode,
    }

}

// Function : to check if the module is in reports or not
export const isCurrentPageIsInReports = () => {
    const reportRoutesMap = {
        // vendor side reports
        // "/app/product/digivend/finance/ledger": true,
        "/analytics/vendorSalesReport": true,
        "/analytics/vendorSalesStockItemReport": true,
        "/analytics/vendorInspectionReport": true,
        "/analytics/vendorAsnReport": true,
        "/analytics/shipmentBoxReport": true,
        "/analytics/vendorPoReport": true,
        "/analytics/vendorPoToGrnReport": true,
        "/vendor/analytics/tnaorderstatus": true,
        "/analytics/order/request/report": true,
        "/analytics/top/selling/product": true,
        "/analytics/retailerStockReport": true,
        "/salesManagement/stockDrrMisReport": true,
        "/analytics/stockagingReport": true,
        '/analytics/vendorStockReport': true,
        "/analytics/vendorLedgerReport": true,
        "/analytics/vendorLrReport": true,

        "/analytics/top/selling/product": true,
        "/analytics/retailerPivotalSizeReport": true,
        "/analytics/retailerSalesCogsReport": true,
        "/analytics/top/selling/product": true,
        "/analytics/chooseStoreProfile": true,
        "/digiars/inventoryPlanningReport": true,
        "/inventoryPlanning/report4": true,
        "/digiars/sales/mbo/report": true,
        "/digiars/sales/weekly/report": true,
        "/digiars/stock/size/set/report": true,
        "/digiars/mboReport": true,
        "/inventoryPlanning/report2": true,
        "/inventoryPlanning/reordingReport": true,
        "/inventoryPlanning/transferOrderReport": true,
        "/inventoryPlanning/storePerformance": true,
        "/inventoryPlanning/sell/through/report": true,
        "/inventoryPlanning/catSizeReport": true,
        "/digiars/salesInventoryReport": true,
        "/inventoryPlanning/topBottomReports": true,
        "/inventoryPlanning/lastMonthReport": true,
        "/inventoryPlanning/topMovingReport": true,
        "/inventoryPlanning/saleContribution": true,
        "/inventoryPlanning/site/to/site/movement/report": true,
        "/analytics/retailerSalesStockItemReport": true,
        "/salesManagement/salesDrrMisReport": true,
        "/salesManagement/so/status/report": true,
        "/analytics/retailerSalesReport": true,
        "/analytics/retailerSalesReturnReport": true,
        "/inventoryPlanning/bill/report": true,
        "/analytics/retailerSalesReport/SALES_PERSON_REPORT": true,
        "/inventoryPlanning/report5": true,
        "/inventoryPlanning/report10": true,
        "/inventoryPlanning/report7": true,
        "/analytics/retailerGvAnalysis": true,
        "/inventoryPlanning/report3": true,
        "/analytics/retailerChannelWiseNetSalesAnalysis": true,
        "/analytics/hitLineReport": true,
        "/analytics/footfallReport": true,
        "/analytics/jistReport": true,
        "/inventoryPlanning/report6": true,
        "/inventoryPlanning/report9": true,
        "/inventoryPlanning/report8": true,
        "/inventoryPlanning/report1": true,
        "/analytics/retailerSalesReport/ENT_SALES_ITEM_REPORT": true,
        "/inventoryPlanning/dailyTrackerKpi/new": true,
        "/inventoryPlanning/grn/report": true,
        "/analytics/opsreport": true,
        "/analytics/dispatchreport": true,
        "/analytics/retailerPoReport": true,
        "/analytics/entPurchaseReport": true,
        "/analytics/potogrnreport": true,
        "/analytics/multiLevelApprovalLogs": true,
        "/analytics/tnaorderstatus": true,
        // "/vendor/analytics/tnaorderstatus": true, // commented out
        "/analytics/poGrnException": true,
        "/analytics/otb/forcaste/report": true,
        "/analytics/orderReport": true,
        "/analytics/vendorPoItemReport": true,
        "/analytics/otbReport": true,
        "/analytics/retailerLedgerReport": true,
        "/analytics/retailerOutstandingReport": true,
        "/analytics/customerOutstandingReport": true,
        "/analytics/customerLedgerReport": true,
        "/analytics/retailerStockReport": true,
        "/salesManagement/stockDrrMisReport": true,
        "/analytics/stockagingReport": true,
        "/mdm/factoryaddressreport": true,
        "/analytics/logisticsPaymentReconciliation": true,
        "/analytics/appointmentReport": true,
        "/analytics/logisticsInventoryReport": true,
        "/analytics/retailerLrReport": true,
        "/vendor/loginLogoutReport": true,
        "/vendor/activityReport": true,
        // "/analytics/autoAsnReport": true, // commented out
        "/analytics/shipmentBoxReport": true,
        "/analytics/retailerInspectionReport": true,
        "/analytics/retailerAsnReport": true,
        "/analytics/autoAsnReport": true,
        "/analytics/custom/sales/grc/report": true,
        "/digiars/stock/size/set/report/v2": true,
        "/inventoryPlanning/:jobType/job/run/report" : true,
        "/digiars/sales/price/movement/report": true,
        "/data-api-monitor": true,
        "/app/data/settings/logs/api": true,
        "/app/data/settings/config/global": true,
        "/analytics/poSyncMonitoring": true,
        "/analytics/salesReportNew": true,
        "/app/product/grievance": true,
        "/analytics/channel/wise/daily/sales/report": true,
        "/analytics/stockagingReportV2": true,
        "/analytics/abcAssortmentAnalysis": true,
        "/analytics/freshStockAndDiscountStock" : true,
        "/analytics/custom/stock/point/report" : true,
        "/analytics/custom/pending/purchase/order/report": true,
        "/analytics/otbLogs": true,
        "/app/data/master/hsn": true,
        "/app/data/master/itemhierarchy": true,
        "/app/data/master/marginrule": true,
        "/app/data/master/articlemaster": true,
        "/app/product/digiproc/purchase/orders/raise": true
    };

    const path = window.location.hash.replace(/^#/, '').split('?')[0]; // remove hash + any query
    return !!reportRoutesMap[path];
}

// Function : To get the storage key for the given tab user
export const getDataStorageKey = () => {
    let tokenData = parseJwt(sessionStorage.getItem("token"));
    return `Supplymint-ai-local-storage-${tokenData?.jti || ""}`
}

export const useIsKeyPresentInTheUrl = () => {
    const location = useLocation();

    const urlSearchParams = new URLSearchParams(location.search);
    const isKeyPresentInTheUrl = (config = {}) => {
        let {
            key
        } = config || {};
        let params = Object.fromEntries(urlSearchParams.entries());
        return params?.[key] ? JSON.parse(decodeURIComponent(params?.[key])) : false
    }
    return { isKeyPresentInTheUrl }
}

export const translateObjectValues = (obj) => {
    const translated = {};
    for (const key in obj) {
        translated[key] = LanguageTranslator({ children: obj[key] });
    }
    return translated;
};

export const getHeadersType = (obj, keys) => {
    return keys?.every(item => Object.keys(obj?.[item]?.["Custom Headers"] || {})?.length > 0) ? "Custom Headers" : "Default Headers"
}

export const moveItemIntoFocus = (id, config = {}) => {
    if (!id) return;
    const item = document.getElementById(id);
    if (!item) return;

    const {
        behavior = "smooth",
        block = "nearest",
        inline = "nearest",
        headerOffset,
    } = config;

    // Find the closest scrollable container
    let scrollContainer = item.parentElement;
    while (scrollContainer && scrollContainer !== document.body && scrollContainer !== document.documentElement) {
        const style = window.getComputedStyle(scrollContainer);
        const overflowY = style.overflowY || style.overflow;
        if (overflowY === 'auto' || overflowY === 'scroll') {
            break;
        }
        scrollContainer = scrollContainer.parentElement;
    }

    if (scrollContainer && scrollContainer !== document.body && scrollContainer !== document.documentElement) {
        const thead = scrollContainer.querySelector('thead');
        const stickyHeaderHeight = headerOffset !== undefined
            ? headerOffset
            : (thead ? thead.offsetHeight : 36);

        const itemRect = item.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();

        const visibleTop = containerRect.top + stickyHeaderHeight;
        const visibleBottom = containerRect.bottom;

        if (block === "start") {
            const scrollDiff = itemRect.top - visibleTop;
            scrollContainer.scrollBy({ top: scrollDiff - 4, behavior });
            return;
        }

        if (block === "center") {
            const visibleHeight = visibleBottom - visibleTop;
            const targetY = visibleTop + (visibleHeight / 2) - (itemRect.height / 2);
            const scrollDiff = itemRect.top - targetY;
            scrollContainer.scrollBy({ top: scrollDiff, behavior });
            return;
        }

        // block === "nearest" (default)
        // If item is scrolled underneath sticky header or above visible area:
        if (itemRect.top < visibleTop) {
            const scrollDiff = itemRect.top - visibleTop;
            scrollContainer.scrollBy({ top: scrollDiff - 4, behavior });
            return;
        }

        // If item is below the bottom of visible container:
        if (itemRect.bottom > visibleBottom) {
            const scrollDiff = itemRect.bottom - visibleBottom;
            scrollContainer.scrollBy({ top: scrollDiff + 4, behavior });
            return;
        }

        // Already visible within the visible area:
        return;
    }

    // Fallback if no scroll container found:
    if (typeof item.scrollIntoView === 'function') {
        item.scrollIntoView({ behavior, block: block === "start" ? "center" : block, inline });
    }
};

export const getAsnNumberTag = (item) => {
    return (
        <div style={{ display: "flex", flexDirection: "row", }}>
            {item?.["createdWithBoxes"] == 1 && <Tooltip
                overlayClassName='!p-[0]'
                className="!p-0"
                overlayInnerStyle={{
                    backgroundColor: '#A97142'
                }}
                title={<LanguageTranslator tag='p' className="mb-0 text-xs font-medium text-white">Created With Boxes</LanguageTranslator>}>
                <Package2 size={17} color="#A97142" className="shrink-0" />
            </Tooltip>}
        </div>
    )
}